import { getServiceUrls } from "../services/serviceUrls";

export const getUrls = () => {
  const SERVICE_URL = getServiceUrls();

  return {
    //PlugnPay API
    PAYMENT_URL: `${SERVICE_URL.REACT_APP_PLUGNPAY_URL}`,
    PAYMENT_GATEWAY_ACCOUNT: `${SERVICE_URL.REACT_APP_PLUGNPAY_GATEWAY_ACCOUNT}`,
    PAYMENT_RESPONSE_URL: `${SERVICE_URL.INVOICE_SERVICE}/webhook/payment/fbo-invoice`,

    //FBO-Services API
    GET_FBO_CUSTOMER: `${SERVICE_URL.FBO_SERVICE}/customer`,
    GET_FBO_USER_PROFILE: `${SERVICE_URL.FBO_SERVICE}/profile/me`,
    USER_PROFILE_SETUP: `${SERVICE_URL.FBO_SERVICE}/profile/setup`,
    GET_ASSOCIATED_FBO_CUSTOMERS: `${SERVICE_URL.FBO_SERVICE}/customer/me`,
    GET_LANDING_FEE_DATA: `${SERVICE_URL.FBO_SERVICE}/landing-fee`,
    ADD_LANDING_FEE_DATA: `${SERVICE_URL.FBO_SERVICE}/landing-fee`,
    SEARCH_LANDING_FEE_BY_TRIP_ID: `${SERVICE_URL.FBO_SERVICE}/landing-fee/search`,
    CREATE_MANUAL_FLIGHT_PLAN: `${SERVICE_URL.FBO_SERVICE}/landing-fee/manual-flight-plan`,
    
    REJECT_PRIVATE_TRIP : (tripId) =>
      `${SERVICE_URL.FBO_SERVICE}/landing-fee/cfp/${tripId}/reject`,
    REJECT_TRIP: (tripId) =>
      `${SERVICE_URL.FBO_SERVICE}/landing-fee/${tripId}/reject`,
    GET_SUBMITTED_FUEL_READING: `${SERVICE_URL.FBO_SERVICE}/fuel-royalty/submissions`,
    GET_FILTERED_SUBMITTED_FUEL_READING: `${SERVICE_URL.FBO_SERVICE}/fuel-royalty/filter`,
    ADD_FUEL_METER_DATA: `${SERVICE_URL.FBO_SERVICE}/fuel-royalty/meter`,
    SUBMIT_FUEL_METER_READING: `${SERVICE_URL.FBO_SERVICE}/fuel-royalty/reading`,
    GET_FUEL_METERS: `${SERVICE_URL.FBO_SERVICE}/fuel-royalty/meters`,
    GET_FBO_PROFILES: `${SERVICE_URL.FBO_SERVICE}/review-profile`,
    SEARCH_FBO_USER: `${SERVICE_URL.FBO_SERVICE}/profile/search`,
    ADD_DEVICE_TOKEN: `${SERVICE_URL.FBO_SERVICE}/profile/add-device-token`,
    REMOVE_DEVICE_TOKEN: `${SERVICE_URL.FBO_SERVICE}/profile/remove-device-token`,
    INVITE_FBO_USER: `${SERVICE_URL.FBO_SERVICE}/review-profile/invite`,
    EDIT_FBO_PROFILE_ROLE: (associationId) =>
      `${SERVICE_URL.FBO_SERVICE}/profile/association/${associationId}/role`,
    DELETE_FBO_PROFILE: (associationId) =>
      `${SERVICE_URL.FBO_SERVICE}/profile/association/${associationId}/delete`,
    GET_LANDING_FEE_INVOICE: (invoiceId) =>
      `${SERVICE_URL.FBO_SERVICE}/landing-fee/invoice/${invoiceId}`,
    GET_FUEL_ROYALTY_INVOICE: (invoiceId) =>
      `${SERVICE_URL.FBO_SERVICE}/fuel-royalty/invoice/${invoiceId}`,
    GET_LAND_LEASE_INVOICE: (invoiceId) =>
      `${SERVICE_URL.FBO_SERVICE}/land-lease/invoice/${invoiceId}`,

    //User-Services API
    GET_COUNTRIES_LIST: `${SERVICE_URL.USER_SERVICE}/country`,
    GET_STATES_CITY_LIST: (id) =>
      `${SERVICE_URL.USER_SERVICE}/country/${id}/state-city`,

    //Fee-Services API
    LIST_OF_AIRPORT: `${SERVICE_URL.FEE_SERVICE}/airport`,
    SEARCH_AIRPORT: `${SERVICE_URL.FEE_SERVICE}/airport/search`,

    //Trip-Services API
    LIST_OF_AIRCRAFT: `${SERVICE_URL.TRIP_SERVICE}/aircraft-type`,
    LIST_OF_AIRLINE: `${SERVICE_URL.TRIP_SERVICE}/commercial-airline`,
    GET_AIRCRAFT_BY_REGISTRATION_NUMBER: `${SERVICE_URL.TRIP_SERVICE}/aircraft/by-registration-number`,

    //Invoice-Services API
    GET_FBO_INVOICES: `${SERVICE_URL.INVOICE_SERVICE}/fbo-invoice`,
    GET_FBO_UNPAID_INVOICES: `${SERVICE_URL.INVOICE_SERVICE}/fbo-invoice/unpaid`,
    PAYMENT_VIA_WIRE_TRANSFER: `${SERVICE_URL.INVOICE_SERVICE}/invoice-payment/fbo-wire-transfer`,
    DOWNLOAD_FBO_INVOICE: (invoiceId) =>
      `${SERVICE_URL.INVOICE_SERVICE}/fbo-invoice/vat-complaint-invoice?dynamicsInvoiceId=${invoiceId}`,

    //Messaging-Services API
    GET_NOTIFICATIONS_UNREAD_COUNT: `${SERVICE_URL.MESSAGING_SERVICE}/notifications/unread-count`,
    READ_ALL_NOTIFICATIONS: `${SERVICE_URL.MESSAGING_SERVICE}/notifications/read-all`,
    GET_All_NOTIFICATIONS: `${SERVICE_URL.MESSAGING_SERVICE}/notifications`,
    READ_NOTIFICATION: (notificationId) =>
      `${SERVICE_URL.MESSAGING_SERVICE}/notifications/${notificationId}/read`,
    UNREAD_NOTIFICATION: (notificationId) =>
      `${SERVICE_URL.MESSAGING_SERVICE}/notifications/${notificationId}/unread`,
    DELETE_NOTIFICATION: (notificationId) =>
      `${SERVICE_URL.MESSAGING_SERVICE}/notifications/${notificationId}`,
    GET_BANK_CONFIG: (env) =>
      `${SERVICE_URL.CONFIG_SERVICE}/bank-config/${
        env === "staging" ? "dev" : env
      }`,
    GET_AIRLINE_BY_ID: (airlineId) =>
      `${SERVICE_URL.TRIP_SERVICE}/commercial-airline/${airlineId}`,
    SEARCH_AIRLINE: `${SERVICE_URL.TRIP_SERVICE}/commercial-airline/search`,
    SEARCH_AIRCRAFT: `${SERVICE_URL.TRIP_SERVICE}/aircraft-type/search-by-icao`,

  };
};
